import './ModalBody.css';

import clsx from 'clsx';

interface ModalBodyProps {
  header?: React.ReactNode;
  text?: React.ReactNode;
  buttons?: React.ReactNode;
  className?: string;
}

const ModalBody = ({ header, text, buttons, className }: ModalBodyProps) => {
  return (
    <div className={clsx('control-action-modal-body', className)}>
      {header != null && (
        <h1 className="control-action-modal-body-header">{header}</h1>
      )}
      {text != null && (
        <div className="control-action-modal-body-text">{text}</div>
      )}
      {buttons != null && (
        <div className="control-action-modal-body-buttons">{buttons}</div>
      )}
    </div>
  );
};

export default ModalBody;
